var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Comment-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.91177C3 4.30364 4.38512 3 6.09375 3H17.9062C19.6149 3 21 4.30364 21 5.91176V14.744C21 16.3521 19.6149 17.6558 17.9062 17.6558H12.3067L8.3006 20.8146C8.04934 21.0127 7.69889 21.0559 7.40187 20.9255C7.10485 20.795 6.915 20.5144 6.915 20.2059V17.6558H6.09375C4.38512 17.6558 3 16.3521 3 14.744V5.91177ZM6.09375 4.58823C5.3171 4.58823 4.6875 5.1808 4.6875 5.91177V14.744C4.6875 15.475 5.3171 16.0675 6.09375 16.0675H7.75875C8.22474 16.0675 8.6025 16.4231 8.6025 16.8616V18.5046L11.4581 16.2529C11.61 16.1332 11.8019 16.0675 12 16.0675H17.9062C18.6829 16.0675 19.3125 15.475 19.3125 14.744V5.91176C19.3125 5.1808 18.6829 4.58823 17.9062 4.58823H6.09375ZM6.37255 6.97059C6.37255 6.53201 6.75031 6.17647 7.2163 6.17647H16.7804C17.2463 6.17647 17.6241 6.53201 17.6241 6.97059C17.6241 7.40916 17.2463 7.7647 16.7804 7.7647H7.2163C6.75031 7.7647 6.37255 7.40916 6.37255 6.97059ZM6.37255 10.1471C6.37255 9.70848 6.75031 9.35294 7.2163 9.35294H16.7804C17.2463 9.35294 17.6241 9.70848 17.6241 10.1471C17.6241 10.5856 17.2463 10.9412 16.7804 10.9412H7.2163C6.75031 10.9412 6.37255 10.5856 6.37255 10.1471ZM6.37255 13.3235C6.37255 12.8849 6.75031 12.5294 7.2163 12.5294H12.2796C12.7456 12.5294 13.1234 12.8849 13.1234 13.3235C13.1234 13.7621 12.7456 14.1176 12.2796 14.1176H7.2163C6.75031 14.1176 6.37255 13.7621 6.37255 13.3235Z",
    fill: "#2D2D2D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.a91ac8bbb920a553aedea402d1163272.svg";
export { ForwardRef as ReactComponent };